module.exports = __webpack_public_path__ + "img/1.f1ec37ea.png";